import React, { createContext, useContext, useState } from 'react';

const EvidenciaPraceContext = createContext();

export const EvidenciaPraceProvider = ({ children }) => {
  // Globálny stav pre evidenciu práce
  const [workEntries, setWorkEntries] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [services] = useState({
    'Jednoduché účtovníctvo – neplatca DPH': 90,
    'Jednoduché účtovníctvo – platca DPH': 105,
    'Podvojné účtovníctvo – neplatca DPH': 90,
    'Podvojné účtovníctvo – platca DPH': 120,
    'Jednoduché – neplatca DPH (položka)': 1.1,
    'Jednoduché – platca DPH (položka)': 1.1,
    'Podvojné – neplatca DPH (položka)': 1.1,
    'Podvojné – platca DPH (položka)': 1.1,
    'VFA (vyšlé faktúry)': 0,
    'DFA (došlé faktúry)': 0,
    'Pohľadávky': 0,
    'Záväzky': 0,
    'Banka': 0,
    'Pokladňa': 0,
    'Leasing 1': 0,
    'Leasing 2': 0,
    'ID (interné doklady)': 0,
    'Spracovanie mzdy (1 zamestnanec)': 10,
    'Registrácia zamestnávateľa (SP, ZP, DÚ)': 15,
    'Registrácia zamestnanca (SP, ZP)': 15,
    'Odhlásenie zamestnanca': 15,
    'Pracovná zmluva / dodatok': 15,
    'Mesačné výkazy (SP, ZP, DÚ)': 15,
    'Ročné zúčtovanie dane': 20,
    'Ročné hlásenie dane': 20,
    'Predbežný HV': 70,
    'Analytický výstup': 50,
    'Cashflow forecast': 100,
    'Porovnanie plán vs. skutočnosť': 50,
    'Mesačný komentovaný report': 100,
    'Ad-hoc simulácie a prepočty': 50,
    'Optimalizácia nákladov': 150,
    'Rozpočtovanie / budget': 250,
    'Finančný plán firmy': 450,
    'Účtovná závierka PO': 180,
    'Daňové priznanie PO': 80,
    'Daňové priznanie FO typ B (paušál)': 225,
    'Daňové priznanie FO typ B s účtovnou závierkou': 225,
    'Daňové priznanie FO typ A': 35,
    'Daň z motorových vozidiel (1MV)': 35,
    'Podanie DP k DPH': 25,
    'Dobrovoľná registrácia na DPH - základ': 200,
    'Dobrovoľná registrácia na DPH - rozšírená': 350,
    'Vystavovanie faktúr': 5,
    'Kniha jázd': 40,
    'Cestovný príkaz (tuzemský / zahraničný)': 25,
    'Žiadosť o vrátenie DPH zo zahraničia': 0.5,
    'Excel / reporty pre klienta': 20,
    'Smernice, interné dokumenty': 50,
    'Admin hod sadzba 1 (administratívne hodiny)': 35,
    'Admin hod sadzba 2 (náročnejšie úlohy)': 50,
    'Založenie s. r. o.': 300,
    'Zmena v s. r. o. (bez prevodu OP)': 250,
    'Zmena v s. r. o. (s prevodom OP)': 300,
    'Založenie živnosti': 15,
    'Zmena v živnosti': 10,
    'Zrušenie živnosti': 10,
    'Založenie občianskeho združenia': 150,
    'Príplatok za neúplne dodané podklady - nad 5 ks': 50,
    'Príplatok za zrýchlené spracovanie': 50,
    'Príplatok za chýbajúci dokument do 5 dokumentov': 5,
    'Komplexné spracovanie majetku na úver/splátky': 150,
    'Ľahké zaradenie majetku': 50,
    'Predzávierkové operácie a kontrola': 100,
  });
  const [selectedCompany, setSelectedCompany] = useState('');
  const [filterMonth, setFilterMonth] = useState(new Date().toISOString().slice(0, 7));
  const [showInvoiced, setShowInvoiced] = useState(false);
  const [selectedForInvoice, setSelectedForInvoice] = useState([]);

  return (
    <EvidenciaPraceContext.Provider value={{
      workEntries, setWorkEntries,
      companies, setCompanies,
      services,
      selectedCompany, setSelectedCompany,
      filterMonth, setFilterMonth,
      showInvoiced, setShowInvoiced,
      selectedForInvoice, setSelectedForInvoice
    }}>
      {children}
    </EvidenciaPraceContext.Provider>
  );
};

export const useEvidenciaPrace = () => useContext(EvidenciaPraceContext);
